import React from "react";
import OfficeAndWorkers from "../filterDockets/OfficeAndWorkers";

const FilterAufaDocketsHead = React.memo(({ data, setData, workers }) => {
    return (
        <div className={"InvoicesListFilter"}>

            <p>מיין לפי</p>
            <select
                value={data.sortOption}
                onChange={(event) => setData({ ...data, sortOption: event.target.value })}
            >
                <option value="docketAsc">מספר דוקט - מהנמוך לגבוה</option>
                <option value="docketDesc">מספר דוקט - מהגבוה לנמוך</option>
                <option value="dateAsc">תאריך - מהמוקדם למאוחר</option>
                <option value="dateDesc">תאריך - מהמאוחר למוקדם</option>
            </select>

            <p>סטטוס</p>
            <select
                value={data.status}
                onChange={(event) => setData({ ...data, status: event.target.value })}
            >
                <option value="*">הכל</option>
                <option value="0">הזמנה שמורה ל24 שעות</option>
                <option value="1">הזמנה סגורה</option>
                <option value="2">שולם דמי הרשמה</option>
                <option value="3">הזמנה נפלה</option>
                <option value="5">הזמנה חדשה</option>
            </select>

            <p>מספר דוקט</p>
            <input
                type="number"
                value={data.docket_id}
                onChange={(event) => setData({ ...data, docket_id: event.target.value })}
                style={{ width: '7em' }}
            />

            <p>מספר הזמנה</p>
            <input
                type="number"
                value={data.aufa_id}
                onChange={(event) => setData({ ...data, aufa_id: event.target.value })}
                style={{ width: '7em' }}

            />

            <p>תאריך התחלה</p>
            <input
                type="date"
                value={data.date_f}
                onChange={(event) => setData({ ...data, date_f: event.target.value })}
            />

            <p>תאריך סיום</p>
            <input
                type="date"
                value={data.date_e}
                onChange={(event) => setData({ ...data, date_e: event.target.value })}
            />

            <OfficeAndWorkers
                officeValue={data.office}
                setOfficeValue={(v) => setData({ ...data, office: v, work: "*" })}
                workValue={data.work}
                setWorkValue={(v) => setData({ ...data, work: v })}
                workers={workers}
            />
        </div>
    );
});

export default FilterAufaDocketsHead;